import { render, staticRenderFns } from "./popup-do-area.vue?vue&type=template&id=0d7f3efc&scoped=true"
import script from "./popup-do-area.vue?vue&type=script&lang=js"
export * from "./popup-do-area.vue?vue&type=script&lang=js"
import style0 from "./popup-do-area.vue?vue&type=style&index=0&id=0d7f3efc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7f3efc",
  null
  
)

export default component.exports